import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.QBooksAccountLineItemsSection.AccountLineItemsToolbar', {
    headerText: 'Category details',
    lineAmountTypeLabel: 'Amounts are',
});
